<template>
	<div class="flex cursor-pointer">
		<Icon src="/media/icons/sync-icon.svg" css="hover:opacity-70 w-5 h-5" />
	</div>
</template>
